import { styled } from "@mui/system"
import { Button } from "@mui/material"
import { BUTTON_SIZES } from "./constants"

export const StyledButton = styled(Button)(({ theme, btnsize, iconOnly }) => ({
    height: BUTTON_SIZES[btnsize].height,
    fontSize: BUTTON_SIZES[btnsize].fontSize,
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeights.regular,
    borderRadius: "20px",
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    backgroundColor: "transparent",
    padding: BUTTON_SIZES[btnsize].padding,
    display: "flex",
    whiteSpace: "nowrap",

    alignItems: "center",
    gap: 0,
    textTransform: "none",
    "& .MuiButton-startIcon": {
        marginRight: iconOnly ? 2 : 8,
        marginLeft: 0,
    },
    "&:hover": {
        backgroundColor: theme.palette.transparent.white10,
        borderColor: theme.palette.common.white,
    },
    "&.Mui-disabled": {
        opacity: 0.3,
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white,
    },
    "& .MuiButton-startIcon svg": {
        color: theme.palette.icon.main,
    },
    "&.Mui-disabled .MuiButton-startIcon svg": {
        color: theme.palette.icon.disabled,
    },
}))
